import React from 'react'
import { debounce_ } from 'Lib/debounceChange'
import { css } from 'react-emotion'
import { Icon } from 'semantic-ui-react'

const searchBox = css({
  margin: '16px 24px',
  paddingBottom: '4px',
  display: 'flex',
  color: 'rgba(122, 104, 242, 0.2)',
  borderBottom: '1px solid rgba(122, 104, 242, 0.2)',

  '& > input': {
    border: 0,
    outline: 0,
    width: '88%',
    color: 'rgba(0, 0, 0, 0.6)',
    backgroundColor: 'transparent'
  },

  '& > input::placeholder': {
    color: '#d6d4e4'
  }
})

export default function SearchProjects(props) {
  const debouncedOnChange = debounce_(false, 300, props.onChange)()
  return (
    <div className={searchBox}>
      <input placeholder='Search...' onChange={(e) => {
        debouncedOnChange(e.target.value) 
      }}/>
      <Icon aria-hidden="true" name="search" />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/SearchProjects.js